/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

/**
 * RGPD notice displayed under every form collecting personal data.
 * Copy is fixed as per legal requirement (Feb 2026 update).
 */
export const RgpdNotice = ({ className = "", testid }) => (
  <p
    className={`italic mt-2 leading-relaxed ${className}`}
    style={{ fontSize: "11px", color: "#6B7280" }}
    data-testid={testid || "rgpd-notice"}
  >
    <Lock className="inline h-3 w-3 mr-1 -mt-0.5" aria-hidden="true" />
    Vos données sont traitées par MGB School conformément à notre politique de
    confidentialité (RGPD — Règlement UE 2016/679). Elles ne sont jamais
    revendues à des tiers.{" "}
    <Link
      to="/confidentialite"
      className="underline text-[#003087] hover:text-[#F07B1D]"
    >
      → Consulter notre politique de confidentialité
    </Link>
  </p>
);

export default RgpdNotice;
